<template>
  <li class='park-card' @click='sendClick'>
    <div class="park-card__header">
      <h3 class='park-card__name'>{{ park.name }}</h3>
      <img class="park-card__image" :src='park.image.url' :alt='park.image.altText'/>
    </div>
    <div class="park-card__info">
      <p>{{ park.designation }}</p>
      <p><em>{{ park.location }}</em></p>
    </div>
  </li>
</template>

<script>
export default {
  name: 'ParkCard',
  props: ['park'],
  methods: {
    sendClick() {
      this.$emit('clicked')
    }
  }
}
</script>

<style lang='scss' scoped>
.park-card {
  box-shadow: 1px 1px 15px rgba(0,0,0,0.125);
  transition: 0.3s ease;
  max-width: 480px;
  width: 100%;
  background-color: #e2e4e3;

  &:hover {
    box-shadow: 1px 1px 30px rgba(0,0,0,0.75);
    cursor: pointer;
  }
  &__header {
    width: 100%;
    height: 0;
    padding-bottom: 33.333%;
    position: relative;
    background-color: #373d39;
  }
  &__name {
    z-index: 2;
    color: #fff;
    text-shadow: 1px 1px 5px rgba(0,0,0,0.75);
    font-size: 1.5em;
    line-height: 1.25;
    margin: 15px;
    position: absolute;
    top:0;
    left:0;
    width:calc(100% - 30px);
    height:calc(100% - 30px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__image {
    position: absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
    object-fit:cover;
    z-index: 1;
    filter: brightness(0.5);
  }
  &__info {
    padding: 15px;
  }
}
</style>